module.exports = __webpack_public_path__ + "img/ic_baseline-facebook.45f50200.svg";